import React from 'react';
import Spinner from '~/components/views/common/Spinner/Spinner';
import './SplashScreen.pcss';

const SplashScreen: React.FC = () => (
  <div data-testid="splashScreen" className="SplashScreen">
    <Spinner />
    <span>Husqvarna Fleet Services</span>
  </div>
);

export default React.memo(SplashScreen);
